import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    profileUpdate: {},
    profile: {},
  }
}

const state = getDefaultState()

const mutations = {
  SET_PROFILE(state, payload) {
    state.profile = payload
  },
}

const actions = {
  async getProfile({ commit }, payload) {
    const apiResult = await apiService.get(route('member.profile.info'))
    if (apiResult && apiResult.success && apiResult.data) {
      commit('SET_PROFILE', apiResult.data)
    }
  },
  async updateProfile({ commit }, payload) {
    return await apiService.post(payload.url, payload.params || {})
  },
  async createOperationLog({ commit }, payload) {
    return await apiService.post(route('member.profile.operation_log'), payload || {})
  },
  async paginate({ commit }, payload) {
    const apiResult = await apiService.get(route('member.member.paginate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.member.update'), payload || {})
    if (apiResult) {
      return apiResult
    }
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.member.create'), payload || {})
    if (apiResult) {
      return apiResult
    }
  },
  async delete({ commit }, payload) {
    const apiResult = await apiService.post(route('member.member.delete'), payload || {})
    if (apiResult) {
      return apiResult
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
